import * as $ from 'jquery';
import TrainerSelect from './select-trainer';
import LocationSelect from './select-location';
import SessionsTable from './sessions-table';
import SelectAttached from './select-attached';

export default (function() {

    // Init all trainer selects
    $('select.fluffy-control-trainer').each(function() {
        new TrainerSelect($(this));
    });

    // Init all location selects
    $('select.fluffy-control-location').each(function() {
        new LocationSelect($(this));
    });

    // Init all session editors
    $('table.sessions-editor').each(function() {
        var instance = new SessionsTable($(this));
    });

    $('select[data-attached-to]').each(function() {
        SelectAttached($(this));
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

}($, TrainerSelect, LocationSelect, SessionsTable));
